import { render, staticRenderFns } from "./BetonTotal.vue?vue&type=template&id=1981fc65&scoped=true&"
import script from "./BetonTotal.vue?vue&type=script&lang=js&"
export * from "./BetonTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1981fc65",
  null
  
)

export default component.exports